module.exports = __webpack_public_path__ + "img/icone-barley.81cb5406.svg";